export const en = {
    CLICKS: 'Clicks',
    CPC: 'CPC',
    CPM: 'CPM',
    CTR: 'CTR',
    DEAL_TYPE: 'Type',
    MIN_PRICE: 'Min. CPM',
    NAME: 'Name',
    SHOWS: 'Impressions',
    SPENT: 'Expenditure',
    STATUS: 'Status',
    'without-nds': 'Without VAT'
};
